@if((session$ | async)?.sessionId && !isPartner) {
<div class="home-dashboard">
  <app-customer-home></app-customer-home>
</div>
}
@else if((session$ | async)?.sessionId && isPartner) {
<div class="home-dashboard">
  <app-partner-home></app-partner-home>
</div>
}
@else
{
<div>
  <app-left-column></app-left-column>
</div>
<div class="main-home">
  @for (eachItem of menuItems;track $index){
  @if(displayMenu(eachItem)){
  <div class="each-function">
    <a class="header-link" [routerLink]="eachItem.path" [queryParams]="{from: 'home'}" routerLinkActive="active">
      {{eachItem.object+".header" | translate }}
    </a>
    <br>
    <span style="padding-bottom: -10px">
      {{eachItem.object+".description" | translate }}
    </span>
  </div>

  }
  }
</div>
<div>
  <app-right-column></app-right-column>
</div>
}
